// extracted by mini-css-extract-plugin
module.exports = {"billing-address-info":"BillingInformationData_billing-address-info__P2Yi7"};